import React, { useEffect, useRef, useState } from "react";
import { Col, Dropdown, Modal, Row } from "react-bootstrap";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";
import axios from "../../API/axios";
import UpdateJob from "../ManageJob/UpdateJob";
import JobMatchWeightsModal from "../ManageJob/JobMatchWeightsModal";
import RecommendedCandidatesModal from "../ManageJob/RecommendedCandidatesModal";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import ShareSharpIcon from '@mui/icons-material/ShareSharp';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import UpdateSharpIcon from '@mui/icons-material/UpdateSharp';
import ContentCopySharpIcon from '@mui/icons-material/ContentCopySharp';
import PsychologySharpIcon from '@mui/icons-material/PsychologySharp';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import WorkOffSharpIcon from '@mui/icons-material/WorkOffSharp';
import { Portal } from "../../components/Portal";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { debounce } from "lodash";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { customStyles } from "../../selectStyles";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
  fetchSkillsByIndustry,
  quickAddSkill,
  splitSkillPayload,
} from "../../utils/industryScopedMaster";
import {
  creatableSkillSelectDefaults,
  onCreatableInputChange,
} from "../../utils/creatableSelectHelpers";
import SkillSuggestChips from "../../components/SkillSuggestChips";

const JobAction = ({
  item,
  AllJobList,
  setJobList,
  jobList,
  totalPages,
  setTotalPages,
  page,
  setCompanyStats,
  companyStats
}) => {
  const sessionId = localStorage.getItem("sessionId");
  const companyJobCount = localStorage.getItem("companyJobCount");
  console.log("itemssssssss", item);
  const { t } = useTranslation();
  const dropdownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const language = localStorage.getItem("Lang");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [showJobModal, setShowJobModal] = useState(false);
  const [showMatchWeights, setShowMatchWeights] = useState(false);
  const [showRecommendedCandidates, setShowRecommendedCandidates] = useState(false);
  console.log('companyStatsiiiii', companyStats);

  useEffect(() => {
    const onFix = (event) => {
      const detail = event?.detail || {};
      if (Number(detail.jobId) !== Number(item?.jobId)) return;
      const field = String(detail.field || "").toLowerCase();
      if (field === "skills") {
        handleOpenAddSkill();
      } else if (field === "weights" || field.includes("weight")) {
        setShowMatchWeights(true);
      } else {
        openJobModal();
      }
    };
    window.addEventListener("wlj-fix-job", onFix);
    return () => window.removeEventListener("wlj-fix-job", onFix);
  }, [item?.jobId]);
  const openJobModal = () => {
    setShowJobModal(true);
  };
  const closeJobModal = () => {
    setShowJobModal(false);
  };

  //************************Delete Post start  ************************//
  const [show, setShow] = useState(false);
  const handleDeleteClose = () => {
    setShow(false);
  };

  const deleteJob = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: item.jobId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .delete(`Job/DeleteJob`, {
          data: responseData, 
        })
        .then((res) => {
  setShow(!show);
  setToastMessage(res?.data?.message);
  setShowToast(true);

    setJobList((prevPostList) =>
      prevPostList?.filter((post) => post?.jobId !== item?.jobId)
    );

    if ((jobList?.length - 1) % 10 === 0 && page === totalPages) {
      setTotalPages(totalPages - 1);
    }

   // ✅ decrement ONCE 
      setCompanyStats((prev) => ({
        ...prev,
        totalJobs: Math.max((prev?.totalJobs || 1) - 1, 0),
      })); 

  const updatedCount = companyJobCount - 1;
  localStorage.setItem("companyJobCount", updatedCount);
 
  if (updatedCount === 0) {
    AllJobList(page);
  }
});

    
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response?.data?.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response?.data?.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Delete Post End  ************************//

  //************************Close Job start  ************************//
  const [showCloseJob, setShowCloseJob] = useState(false);
  const handleCloseJobModalClose = () => {
    setShowCloseJob(false);
  };

  const closeJob = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: item.jobId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .post(`Job/CloseJob`, responseData)
        .then((res) => {
          setShowCloseJob(false);
          setToastMessage(res?.data?.message);
          setShowToast(true);

          const updatedJob = res?.data?.responseData?.viewJob;
          setJobList((prevPostList) =>
            prevPostList?.map((post) =>
              post?.jobId === item?.jobId
                ? { ...post, ...updatedJob, isClosed: true }
                : post
            )
          );
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response?.data?.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response?.data?.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Close Job End  ************************//

  const [shareModal, setShareModal] = useState(false);
  const [shareUrl, setShareUrl] = useState();
  const sharePost = async () => {
    const sharePost = {
      deviceType: "Web",
      id: item.jobId,
      type: 2,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post("SMFeatures/SaveShareURL", sharePost).then((res) => {
        // console.log(res.data.responseData.value);
        setShareUrl(res.data.responseData.value);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const copyPost = async () => {
    const copyData = {
      deviceType: "Web",
      id: item.jobId,
      type: 2,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post("SMFeatures/SaveShareURL", copyData).then((res) => {
        navigator.clipboard.writeText(res.data.responseData.value);
        // toast.success('Link Copied')
        setToastMessage(res.data.message);
        setShowToast(true);
      });
    } catch (e) {
      console.log(e);
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Get Skill DDL Start  ************************//
  const [skillvalue, setskillValue] = useState([]);
  const [skillpage, setskillPage] = useState(0);
  const [skilltyped, setSkilltyped] = useState("");
  const [skillisLoading, setskillIsLoading] = useState(false);
  const [skilloptions, setskillOptions] = useState([]);
  const [skilltotalPages, setskillTotalPages] = useState(0);
  const [jobIndustryId, setJobIndustryId] = useState(item?.industryId || null);

  const logValue = debounce((typed) => {
    setSkilltyped(typed || "");
  }, 250);

  const loadJobIndustry = async () => {
    if (jobIndustryId > 0 || !item?.jobId) return jobIndustryId;
    try {
      const res = await axios.get(
        `Job/GetJobDetails?DeviceType=Web&JobId=${item.jobId}&langKey=${language === "en" ? "" : language}`
      );
      const viewJob = res?.data?.responseData?.viewJob || {};
      const fitid = viewJob.industryId || viewJob.IndustryId || null;
      if (fitid) setJobIndustryId(fitid);
      return fitid;
    } catch {
      return jobIndustryId;
    }
  };

  const addOptions = async (pageNumber = skillpage + 1, replace = false) => {
    setskillIsLoading(true);
    try {
      const fitid = (await loadJobIndustry()) || jobIndustryId;
      const { options, totalPages } = await fetchSkillsByIndustry({
        fitid: fitid > 0 ? fitid : undefined,
        search: skilltyped,
        pageNumber,
        language,
      });
      setskillPage(pageNumber);
      setskillTotalPages(totalPages);
      setskillOptions((prev) =>
        replace
          ? options
          : [...prev, ...options].filter(
              (opt, idx, all) =>
                idx === all.findIndex((x) => String(x.value) === String(opt.value))
            )
      );
    } catch (error) {
      console.log(error);
    } finally {
      setskillIsLoading(false);
    }
  };

  const handleOpen = () => {
    setskillPage(0);
    setskillOptions([]);
    addOptions(1, true);
  };

  const handleChange = (selected) => {
    setskillValue(selected || []);
    setskillPage(0);
  };

  const handleInputChange = (typed) => {
    logValue(typed);
    if (!typed) setskillPage(0);
  };

  const handleMenuScrollToBottom = () => {
    if (skillpage < skilltotalPages) {
      addOptions(skillpage + 1, false);
    }
  };

  useEffect(() => {
    if (skilltyped) {
      addOptions(1, true);
    }
  }, [skilltyped]);

  //************************ Get Skill DDL End  ************************//
  const [showAddSkill, setShowAddSkill] = useState(false);
  const handleOpenAddSkill = () => setShowAddSkill(true);
  const handleCloseAddSkill = () => {
    setShowAddSkill(false);
    setskillValue([]);
  };
  const jobSkills = async () => {
    const { skillIds, skillNames } = splitSkillPayload(skillvalue);
    if (skillIds.length === 0 && skillNames.length === 0) {
      setWarningToastMessage(t("modals.Please fill all the required fields"));
      setShowWarningToast(true);
      return;
    }
    const Data = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: item?.jobId,
      skillIds,
      skillNames,
      industryId: jobIndustryId || undefined,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post("Job/SetJobSkills", Data).then((res) => {
        setToastMessage(res.data.message);
        setShowToast(true);
        handleCloseAddSkill();
      });
    } catch (e) {
      console.log(e);
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(null);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [isOwned, setIsOwned] = useState("");
  useEffect(() => {
    jobList?.map((item) => {
      console.log("item.isOwned", item.isOwned);
      
      setIsOwned(item.isOwned);
    });
  }, []);
  console.log("isOwned new ", isOwned);
  // useEffect(() => {
  //   if (show || shareModal || showAddSkill) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [show, shareModal, showAddSkill]);


    const [interviewModal, setInterviewModal] = useState(false)
    const [interviewDetails, setInterviewDetails] = useState('')
   const cleanShortDescription = (htmlString) => {
        return htmlString
          ?.replace(/<h3>/gi, "<div>")
          ?.replace(/<\/h3>/gi, "</div>")
          ?.replace(/<strong>/gi, "")
          ?.replace(/<\/strong>/gi, "");
      };
  return (
    <>
    {console.log("item.isOwnedkkk",item)
    }
      {item.isOwned === false ? (
        <div
          className="postMenu pointer "
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <MoreHorizSharpIcon className="material-symbols-sharp" />
          {showDropdown && (
            <Dropdown.Menu
              show={showDropdown}
              ref={dropdownRef}
              className="InteractionModal"
            >
              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    setShareModal(true);
                    sharePost();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <ShareSharpIcon className="material-symbols-sharp me-2" />

                    <span className="dropdownTxt f-14">{t("Manage Job.Share")}</span>
                  </div>
                  <p className="f-12 dropdownPara">{t("Manage Job.Share Job")} </p>
                </div>
              </Dropdown.Item>
              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    copyPost();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <ContentCopySharpIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">{t("Manage Job.Copy Link")}</span>
                  </div>
                  <p className="f-12 dropdownPara">{t("Manage Job.Copy Post Link")}</p>
                </div>
              </Dropdown.Item>
              {item.hiringStatusName === "Scheduled" && (
              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                     setInterviewModal(true)
                     setInterviewDetails(item)
                  }}
                >
                  <div className="d-flex align-items-center">
                    <CalendarMonthIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">{t("Job Application.Interview Details")}</span>
                  </div>
                  <p className="f-12 dropdownPara">{t("Job Application.Interview Details")}</p>
                </div>
              </Dropdown.Item>
          )}
            </Dropdown.Menu>
          )}
        </div>
      ) : (
        <div
          className="postMenu pointer "
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <MoreHorizSharpIcon className="material-symbols-sharp" />

          {showDropdown && (
            <Dropdown.Menu
              show={showDropdown}
              ref={dropdownRef}
              className="InteractionModal"
            >
              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    handleOpenAddSkill();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <PsychologySharpIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">{t("Manage Job.Add Skills")}</span>
                  </div>
                  <p className="f-12 dropdownPara">{t("Manage Job.Job Skills")}</p>
                </div>
              </Dropdown.Item> 
              
              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    setShareModal(true);
                    sharePost();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <ShareSharpIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">{t("Manage Job.Share")}</span>
                  </div>
                  <p className="f-12 dropdownPara"> {t("Manage Job.Share Job")}</p>
                </div>
              </Dropdown.Item>
              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    copyPost();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <ContentCopySharpIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">{t("Manage Job.Copy Link")}</span>
                  </div>
                  <p className="f-12 dropdownPara">{t("Manage Job.Copy Post Link")}</p>
                </div>
              </Dropdown.Item>
              
               <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    openJobModal();
                    toggleDropdown();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <UpdateSharpIcon className="material-symbols-sharp" />
                    <span className="dropdownTxt f-14">{t("Manage Job.Update")}</span>
                  </div>
                  <p className="f-12 dropdownPara">{t("Manage Job.Update Job")}</p>
                </div>
              </Dropdown.Item>

              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    setShowMatchWeights(true);
                    toggleDropdown();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <PsychologySharpIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">Match weights</span>
                  </div>
                  <p className="f-12 dropdownPara">Skills, education, industry &amp; more</p>
                </div>
              </Dropdown.Item>

              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    setShowRecommendedCandidates(true);
                    toggleDropdown();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <PsychologySharpIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">Recommended candidates</span>
                  </div>
                  <p className="f-12 dropdownPara">Rank &amp; assign matching talent</p>
                </div>
              </Dropdown.Item>

              {!item?.isClosed && (
                <Dropdown.Item as="button" className="dropdownList">
                  <div
                    onClick={() => {
                      setShowCloseJob(true);
                      toggleDropdown();
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <WorkOffSharpIcon className="material-symbols-sharp me-2" />
                      <span className="dropdownTxt f-14">{t("Manage Job.Close Job")}</span>
                    </div>
                    <p className="f-12 dropdownPara">
                      {t("Manage Job.Once Closed it can't accept new applications")}
                    </p>
                  </div>
                </Dropdown.Item>
              )}

               <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={() => {
                    setShow(!show);
                    toggleDropdown();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <DeleteOutlineSharpIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">{t("Drafts.Delete")}</span>
                  </div>
                  <p className="f-12 dropdownPara"> 
                    {t("Drafts.Once Deleted it can't be recovered")}
                  </p>
                </div>
              </Dropdown.Item>
            </Dropdown.Menu>
          )}
        </div>
      )}

      {/* <Modal
        show={show}
        size="md"
        centered
        onHide={handleDeleteClose}
        toggle={() => setShow(!show)}
        // className='modal-dialog-centered m'
      >
        <Modal.Header
          className="bg-transparent p-4"
          closeButton
          toggle={() => {
            setShow(!show);
          }}
        >
          <h6 className="f-16 fw-bold">Are you sure you want to delete Job?</h6>
        </Modal.Header>
        <Modal.Body className="text-center">
          <button color="" className="closebtn" onClick={() => deleteJob()}>
            Delete
          </button>
        </Modal.Body>
      </Modal> */}

      {showCloseJob && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("Manage Job.Are You Sure You want to Close Job?")}</h6>

                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseJobModalClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => closeJob()}
                >
                  {t("Manage Job.Close Job")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      {show && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>

                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleDeleteClose();
                  }}
                >
                  close
                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleDeleteClose();
                  }} />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => deleteJob()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      {showJobModal && (
        <UpdateJob
          openModal={openJobModal}
          showModal={showJobModal}
          closeModal={closeJobModal}
          item={item}
          AllJobList={AllJobList}
          setJobList={setJobList}
          jobList={jobList}
          totalPages={totalPages}
          setTotalPages={setTotalPages}
          page={page}
        />
      )}

      <JobMatchWeightsModal
        show={showMatchWeights}
        jobId={item?.jobId}
        compUid={item?.compUid || item?.CompUid}
        onClose={() => setShowMatchWeights(false)}
        onSaved={() => AllJobList?.(page || 1, true)}
      />
      <RecommendedCandidatesModal
        show={showRecommendedCandidates}
        jobId={item?.jobId}
        jobTitle={item?.title}
        onClose={() => setShowRecommendedCandidates(false)}
      />

       {interviewModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("Job Application.Interview Details")}</h6>  
 
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setInterviewModal(false);
                  }}
                />
              </div>
              <Row>
                <Col md={12}>
                  <div className="jobdata-content-cont d-flex flex-column p-3 pb-0">
                    {/* <h6>Company Details</h6> */}

                    <p className="fw-bold d-flex w-100"><img src={interviewDetails.compLogo} width={50} height={50} />
                      <div>
                        <p className="ms-2 fw-bold">{interviewDetails.compName}</p>
                        <p className="ms-2">{interviewDetails.jobTitle}</p>
                        <p className="ms-2">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: cleanShortDescription(
                                  interviewDetails.shortDescription?.length > 60
                                    ? interviewDetails.shortDescription?.slice(0, 60) + "..."
                                    : interviewDetails.shortDescription
                                ),
                              }}
                              style={{ fontSize: "12px", lineHeight: "1.5" }}
                            />
                        </p>
                      </div>
                    </p>
                    </div>
                  <div className="jobdata-content-cont d-flex flex-column p-3 pb-0">
                  {interviewDetails.hiringStatusName === "" || interviewDetails.hiringStatusName === null ? "" : 
                    <p className="fw-bold d-flex w-100"> {t("Job Application.Hiring Status")} : <p className="ms-2">{interviewDetails.hiringStatusName}</p> </p>
                  }
                  {interviewDetails.intrvwPlaceDetails === "" || interviewDetails.intrvwPlaceDetails === null ? "" : 
                    <p className="fw-bold d-flex w-100">{t("Job Application.Place Details")} : <p className="ms-2">{interviewDetails.intrvwPlaceDetails}</p> </p>
                   }
                    {interviewDetails.intrvwPlaceType === ""  || interviewDetails.intrvwPlaceType === null ? "" : 
                    <p className="fw-bold d-flex">{t("Job Application.Place Type")} : <p className="ms-2">{interviewDetails.intrvwPlaceType}</p> </p>
                   }
                    {interviewDetails.scheduleTime === "" || interviewDetails.scheduleTime === null ? "" : 
                    <p className="fw-bold d-flex">{t("Job Application.Schedule Time")} : <p className="ms-2">{moment(interviewDetails.scheduleTime).format("MMMM D, YYYY, hh:mm A")}</p> </p>
                   }
                    {interviewDetails.remark === "" || interviewDetails.remark === null ? "" : 
                    <p className="fw-bold d-flex" >{t("Job Application.Remark")} : <p className="ms-2 remark">{interviewDetails.remark}</p> </p>
                  }
                  </div>
                </Col>
              </Row>

              {/* <div className="text-center mt-2">
                <button
                  color=""
                  className="mainBtn1"
                  onClick={() => {
                    setInterviewModal(false);
                  }
                  }
                >
                  Close
                </button>
              </div> */}
            </div>
          </div>
        </div>
        </Portal>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {/* <Modal
        show={shareModal}
        onHide={() => setShareModal(false)}
        size="xl"
        centered
        toggle={() => setShareModal(!shareModal)}
      >
        <Modal.Header
          closeButton
          className="bg-transparent p-2 border-bottom"
          toggle={() => setShareModal(!shareModal)}
        >
          <h5 className="main-heading">Share Job</h5>
        </Modal.Header>
        <Modal.Body className="text-center ">
          <FacebookShareButton
            url={shareUrl}
            onClick={() => {
              setShareModal(false);
            }}
          >
            <FacebookIcon size={40} />
          </FacebookShareButton>
          <WhatsappShareButton
            url={shareUrl}
            className="ms-2"
            onClick={() => {
              setShareModal(false);
            }}
          >
            <WhatsappIcon size={40} />
          </WhatsappShareButton>
          <LinkedinShareButton
            url={shareUrl}
            className="ms-2"
            onClick={() => {
              setShareModal(false);
            }}
          >
            <LinkedinIcon size={40} />
          </LinkedinShareButton>
          <TwitterShareButton
            url={shareUrl}
            className="ms-2"
            onClick={() => {
              setShareModal(false);
            }}
          >
            <TwitterIcon size={40} />
          </TwitterShareButton>
          <Row>
            <Col
              className="mt-1 d-flex justify-content-between"
              xs={2}
              lg={2}
            ></Col>
            <Col
              className="mt-1 d-flex justify-content-between"
              xs={2}
              lg={2}
            ></Col>
          </Row>
        </Modal.Body>
      </Modal> */}

      {shareModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2 share-modal">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Share Url")}</h6>

                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setShareModal(false);
                  }}
                >
                  close
                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setShareModal(false);
                  }}
                />
              </div>

              <div className="m-2">
                <FacebookShareButton
                  url={shareUrl}
                  className="svg-icon"
                  onClick={() => {
                    setShareModal(false);
                  }}
                >
                  <FacebookIcon size={40} />
                </FacebookShareButton>
                <WhatsappShareButton
                  url={shareUrl}
                  className="ms-2 svg-icon"
                  onClick={() => {
                    setShareModal(false);
                  }}
                >
                  <WhatsappIcon size={40} />
                </WhatsappShareButton>
                <LinkedinShareButton
                  url={shareUrl}
                  className="ms-2 svg-icon"
                  onClick={() => {
                    setShareModal(false);
                  }}
                >
                  <LinkedinIcon size={40} />
                </LinkedinShareButton>
                {/* <TwitterShareButton
                  url={shareUrl}
                  className="ms-2 svg-icon"
                  onClick={() => {
                    setShareModal(false);
                  }}
                >
                  <TwitterIcon size={40} />
                </TwitterShareButton> */}
                <TwitterShareButton
                                  url={shareUrl}
                                  className="ms-2"
                                  onClick={() => setShareModal(false)}
                                >
                                  <div className="ShareIcon d-flex align-items-center justify-content-center" style={{backgroundColor:"black"}}>
                                    <svg width="8" height="8" viewBox="0 0 24 24" fill="white">
                                      <path d="M18.244 2H21.5l-7.45 8.51L22 22h-6.828l-5.345-6.993L3.95 22H.692l7.97-9.104L2 2h7l4.83 6.338L18.244 2Zm-2.396 18h1.889L8.11 3.889H6.083L15.848 20Z"/>
                                    </svg>
                                  </div>
                                </TwitterShareButton>
              </div>

              <Row>
                <Col
                  className="mt-1 d-flex justify-content-between"
                  xs={2}
                  lg={2}
                ></Col>
                <Col
                  className="mt-1 d-flex justify-content-between"
                  xs={2}
                  lg={2}
                ></Col>
              </Row>
            </div>
          </div>
        </div>
        </Portal>
      )}

      {/* <Modal
        show={showAddSkill}
        onHide={handleCloseAddSkill}
        size="md"
        centered
      >
        <Modal.Header closeButton className="p-3">
          <Modal.Title>Add Skill</Modal.Title>
        </Modal.Header>
        <Modal.Body className="skillModal">
          <div className="mb-4">
            <Select
              defaultValue={skillvalue}
              options={skilloptions}
              optionRenderer={renderOption}
              onOpen={handleOpen}
              onChange={handleChange}
              onMenuScrollToBottom={handleMenuScrollToBottom}
              onInputChange={handleInputChange}
              isClearable
              // onCreateOption={(newOption) => {
              //   setSkillCheck(true);
              //   setNewCreateoption(newOption); // Update the state when a new option is created
              //   // You can also perform other actions here, like adding the new option to the options list
              // }}
              // onCreateOption={handleCreateOption}
              placeholder={"Select Skill"}
              // invalid={display && value === ""}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="text-end">
          <button type="button" className="mainBtn1" onClick={jobSkills}>
            Add Skill
          </button>
        </Modal.Footer>
      </Modal> */}

      {showAddSkill && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center py-2">
                <h6>{t("Manage Job.Add Skills")}</h6>
 
                <CloseSharpIcon
                  className="material-symbols-sharp me-0 pointer"
                  onClick={() => {
                    handleCloseAddSkill();
                  }}
                />

              </div>
              <div className="mb-3 mt-3">
                <CreatableSelect
                  {...creatableSkillSelectDefaults}
                  value={skillvalue}
                  options={skilloptions}
                  onMenuOpen={handleOpen}
                  onChange={handleChange}
                  onMenuScrollToBottom={handleMenuScrollToBottom}
                  onInputChange={onCreatableInputChange(handleInputChange)}
                  onCreateOption={async (inputValue) => {
                    const trimmed = String(inputValue || "").trim();
                    if (!trimmed) return;
                    const pending = { label: trimmed, value: trimmed };
                    setskillOptions((prev) => [...prev, pending]);
                    setskillValue((prev) => [...(Array.isArray(prev) ? prev : []), pending]);
                    const fitid = (await loadJobIndustry()) || jobIndustryId;
                    const created = await quickAddSkill({
                      name: trimmed,
                      fitid: fitid > 0 ? fitid : 0,
                      sessionId,
                      language,
                    });
                    setskillOptions((prev) => [...prev.filter((s) => String(s.value) !== trimmed), created]);
                    setskillValue((prev) => [...(Array.isArray(prev) ? prev.filter((s) => String(s.value) !== trimmed) : []), created]);
                  }}
                  isLoading={skillisLoading}
                  placeholder={t("modals.Select Skill")}
                  noOptionsMessage={() => t("User Profile.Search and Select Skill")}
                  styles={customStyles}
                />
                <SkillSuggestChips
                  title={item?.title || item?.Title}
                  fitid={jobIndustryId}
                  selected={skillvalue}
                  onAdd={(option) => {
                    const exists = (Array.isArray(skillvalue) ? skillvalue : []).some(
                      (s) => String(s.value) === String(option.value) || s.label === option.label
                    );
                    if (!exists) {
                      setskillValue([...(Array.isArray(skillvalue) ? skillvalue : []), option]);
                    }
                  }}
                />
              </div>
              <div className="text-end">
                <button type="button" className="mainBtn1" onClick={jobSkills}>
                  {t("User Profile.Add Skill")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}
    </>
  );
};

export default JobAction;
